import { useIntl } from 'react-intl';
import { Toast } from 'components';
import { labels } from './messages';
import { StyledToast, StyledContent, StyledBullets } from './styled';
import { ErrorToastValidationType } from './types';

export const ErrorToastValidation = ({
  errorMessage,
  errorList,
  handleDismiss,
  handleRetry,
  onlyOneButtonProps
}: ErrorToastValidationType): React.JSX.Element => {
  const intl = useIntl();

  const oneButtonProps = [
    {
      onClick: () => handleDismiss(),
      text: intl.formatMessage(labels.dismissButton)
    }
  ];

  const twoButtonProps = [
    {
      onClick: () => handleDismiss(),
      text: intl.formatMessage(labels.dismissButton)
    },
    {
      onClick: () => {
        if (handleRetry) handleRetry();
      },
      text: intl.formatMessage(labels.retryButton)
    }
  ];
  const props = onlyOneButtonProps ? oneButtonProps : twoButtonProps;

  return (
    <>
      <StyledToast>
        <Toast
          content={
            <StyledContent>
              {errorMessage}
              {errorList &&
                errorList?.map(message => (
                  <StyledBullets
                    key={message?.defaultMessage}
                  >{`\n${intl.formatMessage(message)}`}</StyledBullets>
                ))}
            </StyledContent>
          }
          buttonProps={props}
        />
      </StyledToast>
    </>
  );
};
